// extracted by mini-css-extract-plugin
module.exports = {"container":"DateHighlight_container__3UtJx","today":"DateHighlight_today__1rNeN","tomorrow":"DateHighlight_tomorrow__zpFhJ"};